import React from 'react'
import ReviewImage1 from '../img/review4.png'
import ReviewImage2 from '../img/review5.png'
import ReviewImage3 from '../img/review6.png'
import { FaStar } from "react-icons/fa";
import { FaRegStar } from "react-icons/fa";

const reviewDetails = [
  {
    image:ReviewImage1,
    name:"Samson Kadot",
    comment:"We recently hired Kirche Engineering Consultancy for a complex infrastructure project, and I am thoroughly impressed with their professionalism and expertise. They are very thorough in their business.",
    rating:3
  },
  {
    image:ReviewImage2,
    name:"Yasmin Katana",
    comment:"As a small business owner, I approached Kirche for a renovation project based on their stellar reputation. The consultation process was smooth, and the project plan they developed was tailored to our needs.", 
    rating:4
  },
  {
    image:ReviewImage3,
    name:"Samantha Tai",
    comment: "Kirche Consultancy was a game changer for our tech startup. We needed innovative design and engineering solutions that could scale with our growth, and Kirche delivered beyond our expectations and goals.",
    rating:5
  }
]

const StarRating = ({rating})=>{
  const totalStarts = 5
  return(
    <div className='flex items-center justify-center py-4 gap-5'>
      {[...Array(totalStarts)].map((_, i)=>{
        if(i<rating){
          return <FaStar key={i} className='text-[#FF725E] text-lg'/>;
        }else{
          return <FaRegStar key={i} className='text-[#FF725E] text-lg'/>;
        }
      })}
    </div>
  )
}


const Reviews = () => {
  return (
    <>
      <h1 className="text-5xl mt-16 text-center font-bold max-md:text-5xl max-md:text-center max-sm:text-4xl">REVIEWS</h1>
      <section className="px-14 py-1" id="reviews">
      <div className='mt-20 grid grid-cols-1 gap-14 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1'>
        {reviewDetails.map((reviewDetail, index)=>(
          <div key={index} className='bg-[#f3f3f3] shadow-xl shadow-[#adadad] px-8 py-5 rounded-lg'>
            <div>
              <div className='flex align-middle justify-center'>
                <img src={reviewDetail.image} alt="review" className='w-3/5 ' />
              </div>
              <div className='mt-5'>
                <h2 className='text-center font-bold text-xl text-[#0F788E]'>{reviewDetail.name}</h2>
                <p className='mt-5 text-justify text-sm leading-10 text-[#3d3d3d]'>{reviewDetail.comment}</p>
              </div>
                <StarRating rating={reviewDetail.rating}/>
            </div>
          </div>
        ))}
      </div>
      </section>
    </>
  )
}

export default Reviews